import { h, JSX, FunctionalComponent } from "preact";
import { Icon } from "@uw/icons/types";
const defaultStyle = {
  width: "24px",
  height: "24px",
  display: "flex",
};
const SvgIcon = (props: JSX.SVGAttributes<any>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
    <circle
      cx={12}
      cy={12}
      r={10}
      fill="none"
      stroke="currentColor"
      stroke-dasharray={32}
      stroke-dashoffset={32}
      stroke-width={5}
    >
      <animateTransform
        attributeName="transform"
        dur="1s"
        from="0 12 12"
        repeatCount="indefinite"
        to="360 12 12"
        type="rotate"
      />
    </circle>
  </svg>
);
export const LoadingFeatureIcon: FunctionalComponent<Icon> = ({
  className,
  svgAttrs = {
    width: "100%",
    height: "100%",
  },
  key,
  jsx,
  children,
  ref,
  ...styles
}) => (
  <span
    className={className}
    style={{
      ...defaultStyle,
      ...styles,
    }}
  >
    <SvgIcon {...svgAttrs} />
  </span>
);
